module.exports = __webpack_public_path__ + "static/img/cjhx-logo.bca18f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cjhx-logo.png
// module id = AyWr
// module chunks = 37